import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export const isPathwaysForAllEnabled = (makeImpression: boolean = false) => {
  return makeImpression
    ? GrowthDiscoveryEpicClient.get('enablePathwaysForAll')
    : GrowthDiscoveryEpicClient.preview('enablePathwaysForAll');
};
